import { render, staticRenderFns } from "./ExtensionBuilder.vue?vue&type=template&id=669a9a8e&scoped=true"
import script from "./ExtensionBuilder.vue?vue&type=script&lang=js"
export * from "./ExtensionBuilder.vue?vue&type=script&lang=js"
import style0 from "./ExtensionBuilder.vue?vue&type=style&index=0&id=669a9a8e&prod&lang=scss&scoped=true"
import style1 from "./ExtensionBuilder.vue?vue&type=style&index=1&id=669a9a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669a9a8e",
  null
  
)

export default component.exports